import { RefObject, useEffect, useState } from "react";

export const useScroll = (
  containerRef: RefObject<HTMLDivElement | null>,
  contentRef: RefObject<HTMLDivElement | null>,
) => {
  const [arrowsVisible, setArrowsVisible] = useState({
    left: false,
    right: false,
  });

  const scroll = (direction: "left" | "right") => {
    if (containerRef.current) {
      const scrollAmount =
        direction === "left"
          ? -containerRef.current.clientWidth / 2
          : containerRef.current.clientWidth / 2;
      containerRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const updateArrowsVisibility = () => {
    if (containerRef.current && contentRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setArrowsVisible({
        left: scrollLeft > 0,
        right: scrollLeft < scrollWidth - clientWidth,
      });
    }
  };

  useEffect(() => {
    updateArrowsVisibility();

    window.addEventListener("resize", updateArrowsVisibility);

    return () => {
      window.removeEventListener("resize", updateArrowsVisibility);
    };
  }, []);

  return { arrowsVisible, handleScroll: updateArrowsVisibility, scroll };
};
